import React from "react";
import PropTypes from "prop-types";
import UpcomingWebinars from "containers/Dashboard/UpcomingWebinars/UpcomingWebinars";
import LandingWebinars from "containers/Dashboard/LandingWebinars/LandingWebinars";
import { Link } from "react-router";
import _ from "lodash";
import parse from "html-react-parser";
import PasswordField from "../InputField/PasswordField";
import InputField from "../InputField/InputField";
import FeedbackCarousel from "../../containers/FeedbackCarousel";

const partners = [
  "/assets/img/partner1.png",
  "/assets/img/partner2.png",
  "/assets/img/partner3.png",
  "/assets/img/partner4.png",
  "/assets/img/partner5.jpg",
  "/assets/img/partner6.jpeg",
  "/assets/img/partner7.png",
  "/assets/img/partner8.png",
];

function Landing({
  webinars,
  nextPage,
  page,
  count,
  landingText,
  handleChange,
  inputData,
  handleSubmitLogin,
  userId,
  isMobile,
}) {
  return (
    <div>
      <main className="bg_white" style={{ background: "#F2F2F2" }}>
        <div className="bg_landing_main" style={{ background: "#F2F2F2" }}>
          <div className="bg_landing">
            <svg
              preserveAspectRatio="none"
              height={390}
              id="svg"
              viewBox="0 0 1440 390"
              xmlns="http://www.w3.org/2000/svg"
              class="transition duration-300 ease-in-out delay-150"
            >
              <path
                d="M 0,400 C 0,400 0,200 0,200 C 181.19999999999993,197.73333333333335 362.39999999999986,195.46666666666667 542,210 C 721.6000000000001,224.53333333333333 899.6000000000001,255.86666666666667 1049,257 C 1198.3999999999999,258.1333333333333 1319.1999999999998,229.06666666666666 1440,200 C 1440,200 1440,400 1440,400 Z"
                stroke="none"
                stroke-width="0"
                fill="#f2f2f2"
                fill-opacity="1"
                class="transition-all duration-300 ease-in-out delay-150 path-0"
              ></path>
            </svg>
          </div>
          <div className="heroMain">
            <div className="info">
              <div className="landing-title">
                <h2>Delivering Medical Education</h2>
                <div className="divider" />
                <ul>
                  <li>Online</li>
                  <strong />
                  <li>In-Person</li>
                  <strong />
                  <li>On Demand</li>
                </ul>
              </div>
            </div>
          </div>

          {isMobile && (
            <form onSubmit={handleSubmitLogin} className="auth bad">
              <div className="inputs">
                <InputField
                  field_name="email"
                  value={inputData.email}
                  className="input"
                  onChange={handleChange}
                  label="Email"
                />
                <PasswordField
                  field_name="password"
                  value={inputData.password}
                  className="input"
                  onChange={handleChange}
                  label="Password"
                />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Link to="/users/forgot_password">Forgot password?</Link>
                  <Link to="/users/sign_in/admin" style={{ color: "gray" }}>
                    Admin
                  </Link>
                </div>
              </div>
              <div className="buttons">
                <Link to="/users/sign_up">
                  Not a member? Click here to sign up
                </Link>
                <button
                  type="submit"
                  disabled={inputData.isLoading}
                  className="button_classic"
                >
                  SIGN IN
                </button>
              </div>
            </form>
          )}
          <LandingWebinars
            webinars={webinars.filter((el) => !_.includes([91, 94], el.id))}
            nextPage={() => nextPage(LANDING_WEBINARS)}
            page={page.landing}
            count={count}
            isMobile={isMobile}
          />
          {isMobile && <FeedbackCarousel />}
        </div>
        <div className="member_info landing_flex">
          <div className="BAM_card">
            <h3>Become a Member</h3>
            <p>
              Join MedCafe.ie for unlimited access to CPD recognised content.
            </p>
            <ul>
              <li>100% free to join</li>
              <li>Join live webinars or watch on-demand for 6 months</li>
              <li>Gain CPD recognition</li>
            </ul>
            <div>
              <Link to="/users/sign_up" className="button">
                Become a Member
              </Link>
              <a href="mailto:support@medcafe.ie" className="button">
                Email Us
              </a>
            </div>
          </div>
          <div className="landing_info new">
            <div className="landing_section_info">
              <img src="/assets/img/cpd-hours.png" alt="image" />
              <h3>Interactive Sessions</h3>
              <p>Ask questions and receive answers in real time</p>
            </div>
            <div className="landing_section_info">
              <img src="/assets/img/free.png" alt="image" />
              <h3>On Demand</h3>
              <p>Watch on your desktop, tablet or phone anywhere & anytime</p>
            </div>
            <div className="landing_section_info">
              <img src="/assets/img/local.png" alt="image" />
              <h3>Hybrid Meetings</h3>
              <p>Your choice of online & in-person events</p>
            </div>
            <div className="landing_section_info">
              <img src="/assets/img/cpd-hours.png" alt="image" />
              <h3>CPD Locker</h3>
              <p>Accredited webinars & live streams all in one place</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

Landing.defaultProps = {};

Landing.propTypes = {};

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing/Landing.jsx